const SOFT_TOKEN = "softToken/SOFT_TOKEN";
export const GET_DEVICE = `${SOFT_TOKEN}_GET_DEVICE`;
export const GET_DEVICE_STATUS = `${SOFT_TOKEN}_GET_DEVICE_STATUS`;
export const DELETE_DEVICE = `${SOFT_TOKEN}_DELETE_DEVICE`;
export const REGISTER_DEVICE = `${SOFT_TOKEN}_REGISTER_DEVICE`;
export const GET_TOKEN = `${SOFT_TOKEN}_GET_TOKEN`;

// Action types
export const types = {
    SOFT_TOKEN_GET_DEVICE: `${GET_DEVICE}_REQUEST`,
    SOFT_TOKEN_GET_DEVICE_SUCCESS: `${GET_DEVICE}_SUCCESS`,
    SOFT_TOKEN_GET_DEVICE_ERROR: `${GET_DEVICE}_ERROR`,

    SOFT_TOKEN_GET_DEVICE_STATUS: `${GET_DEVICE_STATUS}_REQUEST`,
    SOFT_TOKEN_GET_DEVICE_STATUS_SUCCESS: `${GET_DEVICE_STATUS}_SUCCESS`,
    SOFT_TOKEN_GET_DEVICE_STATUS_ERROR: `${GET_DEVICE_STATUS}_ERROR`,

    SOFT_TOKEN_DELETE_DEVICE: `${DELETE_DEVICE}_REQUEST`,
    SOFT_TOKEN_DELETE_DEVICE_SUCCESS: `${DELETE_DEVICE}_SUCCESS`,
    SOFT_TOKEN_DELETE_DEVICE_ERROR: `${DELETE_DEVICE}_ERROR`,

    SOFT_TOKEN_REGISTER_DEVICE: `${REGISTER_DEVICE}_REQUEST`,
    SOFT_TOKEN_REGISTER_DEVICE_SUCCESS: `${REGISTER_DEVICE}_SUCCESS`,
    SOFT_TOKEN_REGISTER_DEVICE_ERROR: `${REGISTER_DEVICE}_ERROR`,

    SOFT_TOKEN_REGISTER_DEVICE_REPLACE: `${REGISTER_DEVICE}_REPLACE_REQUEST`,
    SOFT_TOKEN_REGISTER_DEVICE_REPLACE_SUCCESS: `${REGISTER_DEVICE}_REPLACE_SUCCESS`,
    SOFT_TOKEN_REGISTER_DEVICE_REPLACE_ERROR: `${REGISTER_DEVICE}_REPLACE_ERROR`,

    SOFT_TOKEN_GET_TOKEN: `${GET_TOKEN}_REQUEST`,
    SOFT_TOKEN_GET_TOKEN_SUCCESS: `${GET_TOKEN}_SUCCESS`,
    SOFT_TOKEN_GET_TOKEN_ERROR: `${GET_TOKEN}_ERROR`,

    SOFT_TOKEN_GET_DEVICE_USER: `${GET_TOKEN}_DEVICE_USER_REQUEST`,
    SOFT_TOKEN_GET_DEVICE_USER_SUCCESS: `${GET_TOKEN}_DEVICE_USER_SUCCESS`,
    SOFT_TOKEN_GET_DEVICE_USER_ERROR: `${GET_TOKEN}_DEVICE_USER_ERROR`,

    SOFT_TOKEN_GET_TOKEN_SEE: `${GET_TOKEN}_SEE_REQUEST`,
    SOFT_TOKEN_GET_TOKEN_SEE_SUCCESS: `${GET_TOKEN}_SEE_SUCCESS`,
    SOFT_TOKEN_GET_TOKEN_SEE_ERROR: `${GET_TOKEN}_SEE_ERROR`,

    SOFT_TOKEN_DELETE_DEVICE_PRE: "softToken/SOFT_TOKEN_DELETE_DEVICE_PRE",
    SOFT_TOKEN_REGISTER_DEVICE_PRE: "softToken/SOFT_TOKEN_REGISTER_DEVICE_PRE",
    SOFT_TOKEN_REGISTER_DEVICE_PRE_SUCCESS: "softToken/SOFT_TOKEN_REGISTER_DEVICE_PRE_SUCCESS",
    SOFT_TOKEN_SET_LAST_COMPONENT_UNMOUNT_DATE: "softToken/SOFT_TOKEN_SET_LAST_COMPONENT_UNMOUNT_DATE",
    SOFT_TOKEN_CLEAN_TOKEN_INFO: "softToken/SOFT_TOKEN_CLEAN_TOKEN_INFO",
};

// Initial state
export const INITIAL_STATE = {
    fetching: false,
    configuredDevice: undefined,
    device: {},
    devices: [],
    deviceIdentification: undefined,
    deviceStatus: "NO_DEVICE",
    softokenRegisteredByOtherUser: true,
    tokenInfo: {
        token: 0,
        tokenInitDateInMilis: Date.now(),
        remainingTime: 0,
    },
    see: {
        data: null,
    },
};

// Reducer
export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case types.SOFT_TOKEN_GET_DEVICE:
            return { ...state, fetching: true };
        case types.SOFT_TOKEN_GET_DEVICE_SUCCESS:
            return {
                ...state,
                configuredDevice: action.configuredDevice,
                softokenRegisteredByOtherUser: action.softokenRegisteredByOtherUser,
                fetching: false,
            };
        case types.SOFT_TOKEN_GET_DEVICE_ERROR:
            return { ...state, softokenRegisteredByOtherUser: false, fetching: false };
        case types.SOFT_TOKEN_GET_DEVICE_STATUS_SUCCESS:
            return {
                ...state,
                deviceStatus: action.deviceStatus,
                tokenInfo: action.tokenInfo,
                oldTokenInfo: action.oldTokenInfo,
            };
        case types.SOFT_TOKEN_DELETE_DEVICE_PRE:
            return { ...state, device: action.device };
        case types.SOFT_TOKEN_REGISTER_DEVICE_PRE_SUCCESS:
            return { ...state, device: action.device };
        case types.SOFT_TOKEN_GET_TOKEN:
            return { ...state, fetching: false };
        case types.SOFT_TOKEN_GET_TOKEN_ERROR:
            return { ...state, deviceStatus: action.deviceStatus, fetching: false };
        case types.SOFT_TOKEN_GET_TOKEN_SUCCESS:
            return {
                ...state,
                tokenInfo: action.tokenInfo,
                oldTokenInfo: action.oldTokenInfo,
                fetching: false,
                deviceStatus: "SUCCESS",
            };
        case types.SOFT_TOKEN_GET_TOKEN_SEE_SUCCESS:
            return {
                ...state,
                see: action.see,
            };
        case types.SOFT_TOKEN_GET_DEVICE_USER:
            return { ...state, fetching: true, deviceStatus: "FETCHING" };
        case types.SOFT_TOKEN_GET_DEVICE_USER_SUCCESS:
            return {
                ...state,
                devices: action.devices,
                fetching: false,
                deviceStatus: "SUCCESS",
            };
        case types.SOFT_TOKEN_REGISTER_DEVICE:
            return { ...state, fetching: true, deviceStatus: "FETCHING" };
        case types.SOFT_TOKEN_REGISTER_DEVICE_SUCCESS:
            return {
                ...state,
                deviceIdentification: action.deviceIdentification,
                fetching: false,
                deviceStatus: "SUCCESS",
            };
        case types.SOFT_TOKEN_DELETE_DEVICE:
            return { ...INITIAL_STATE, fetching: true, deviceStatus: "FETCHING" };
        case types.SOFT_TOKEN_DELETE_DEVICE_SUCCESS:
            return { ...INITIAL_STATE, fetching: false, deviceStatus: "SUCCESS" };
        case types.SOFT_TOKEN_DELETE_DEVICE_ERROR:
            return { ...state, fetching: false, deviceStatus: action.deviceStatus };

        case types.SOFT_TOKEN_REGISTER_DEVICE_REPLACE:
            return { ...state, fetching: true, deviceStatus: "FETCHING" };
        case types.SOFT_TOKEN_REGISTER_DEVICE_REPLACE_ERROR:
            return { ...state, fetching: false, deviceStatus: action.deviceStatus };
        case types.SOFT_TOKEN_REGISTER_DEVICE_REPLACE_SUCCESS:
            return {
                ...state,
                deviceIdentification: action.deviceIdentification,
                fetching: false,
                deviceStatus: "SUCCESS",
            };
        case types.SOFT_TOKEN_CLEAN_TOKEN_INFO:
            return { ...state, tokenInfo: undefined };
        default:
            return state;
    }
};

// Action creators
export const actions = {
    getUserDevice: () => ({
        type: types.SOFT_TOKEN_GET_DEVICE,
    }),
    getDeviceStatus: () => ({
        type: types.SOFT_TOKEN_GET_DEVICE_STATUS,
    }),
    deleteUserDevice: (device) => ({
        type: types.SOFT_TOKEN_DELETE_DEVICE,
        device,
    }),
    deleteUserDevicePre: (device) => ({
        type: types.SOFT_TOKEN_DELETE_DEVICE_PRE,
        device,
    }),
    registerDevicePre: () => ({
        type: types.SOFT_TOKEN_REGISTER_DEVICE_PRE,
    }),
    registerUserDevice: (device) => ({
        type: types.SOFT_TOKEN_REGISTER_DEVICE,
        device,
    }),
    registerUserDeviceReplace: (password) => ({
        type: types.SOFT_TOKEN_REGISTER_DEVICE_REPLACE,
        password,
    }),
    getTokenInfo: () => ({
        type: types.SOFT_TOKEN_GET_TOKEN,
    }),
    getDeviceSee: (exchangeToken) => ({
        type: types.SOFT_TOKEN_GET_TOKEN_SEE,
        exchangeToken,
    }),
    getDevicesByUser: () => ({
        type: types.SOFT_TOKEN_GET_DEVICE_USER,
    }),
    cleanTokenInfo: () => ({
        type: types.SOFT_TOKEN_CLEAN_TOKEN_INFO,
    }),
    registerUserDeviceSuccess: (deviceIdentification) => ({
        type: types.SOFT_TOKEN_REGISTER_DEVICE_SUCCESS,
        deviceIdentification,
    }),
    registerUserDeviceError: () => ({
        type: types.SOFT_TOKEN_REGISTER_DEVICE_ERROR,
    }),
};

// Selectors
export const selectors = {
    getFetching: ({ softToken }) => softToken.fetching,
    getConfiguredDevice: ({ softToken }) => softToken.configuredDevice,
    getDevice: ({ softToken }) => softToken.device,
    getTokenInfo: ({ softToken }) => softToken.tokenInfo,
    getDeviceSee: ({ softToken }) => softToken.see,
    getOldTokenInfo: ({ softToken }) => softToken.oldTokenInfo,
    getDeviceIdentification: ({ state }) => state.softToken.deviceIdentification,
    getDeviceStatus: ({ softToken }) => softToken.deviceStatus,
    getDevicesByUser: ({ softToken }) => softToken.devices,
    registerDevicePre: ({ softToken }) => softToken.device,
    isSoftokenRegisteredByOtherUser: ({ softToken }) => softToken.softokenRegisteredByOtherUser,
};
